import { Box, Collapse, IconButton, Stack, Typography } from "@mui/material";
import SectionHeading from "../MostPopularJob/SectionHeading";
import SectionsSecondaryHeading from "../MostPopularJob/SectionsSecondaryHeading";
import { useEffect, useRef, useState } from "react";
import FAQAddIcon from "../../../UI/FAQAddIcon";
import FAQCard from "./FAQCard";
const FAQsCards = [1, 2, 3, 4, 5, 6, 7];
function FAQsSection() {
  return (
    <Stack
      direction="column"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        pt: "130px",
        pb: "60px",
      }}
    >
      <SectionHeading>FAQ</SectionHeading>
      <SectionsSecondaryHeading py="12px">
        Frequently asked questions about our services.
      </SectionsSecondaryHeading>
      <Stack
        direction="row"
        id="faq-cards"
        sx={{
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
          alignItems: "start",
          pt: "40px",
        }}
      >
        {FAQsCards.map((card) => (
          <FAQCard />
        ))}
      </Stack>
    </Stack>
  );
}

export default FAQsSection;
